const authorlist = [
    {
        name: "Sarah Mokhtar",
        institution: "Massachusetts Institute of Technology",
        url: "https://architecture.mit.edu/student/sarah-mokhtar"
    },
    {
        name: "Matthew Beveridge",
        institution: "Massachusetts Institute of Technology",
        url: "https://mattbeveridge.com/"
    },
    {
        name: "Yumeng Cao",
        institution: "Massachusetts Institute of Technology",
        url: "http://yumeng.mit.edu/"
    },
    {
        name: "Iddo Drori",
        institution: "Massachusetts Institute of Technology",
        url: "https://www.mit.edu/~idrori/"
    }
];

export default authorlist;